import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentUrlService {

  public appUrl: string = environment.urlAddress;
  constructor() { }
}
